import React, { useState, useEffect, useCallback } from "react";
import cx from "classnames";
import { useParams } from "react-router-dom";
import { useApolloClient } from "@apollo/client";
import { Select } from "@foris/avocado-suite";
import { modalitiesQuery } from "../graphql/modality.queries";
import { Modality, DataQuery } from "@models/ISchema";
import { PathParams } from "@edhtypes/general";
import { ISelectorModality, IOption } from "./ISelectors";
import css from "./selectors.module.scss";

const ModalitySelect: React.FC<ISelectorModality> = ({
  onCallback,
  department,
  label,
  className,
  shouldHasDepartment = true,
  placeholder,
}) => {
  // Hooks for handle the client and the params
  const client = useApolloClient();
  const { scenario }: PathParams = useParams();
  const [optionsModality, setOptionsModality] = useState<IOption[]>([]);
  const [valueModality, setValueModality] = useState(null);
  const [prevDepartment, setPrevDepartment] = useState(department);
  const [disabled, setDisabled] = useState(false);

  const getModalityOptions = useCallback(async () => {
    try {
      const response = await client.query({
        query: modalitiesQuery,
        variables: { scenarioId: scenario },
      });
      const dataQuery: DataQuery = response?.data?.data;
      const optModalities =
        dataQuery?.modalities?.items?.map((modality: Modality) => ({
          label: `${modality?.code} - ${modality?.name}`,
          value: modality.id,
        })) ?? [];
      setOptionsModality(optModalities);
    } catch (error) {
      console.error(error);
    }
  }, [client, scenario]);

  useEffect(() => {
    if (shouldHasDepartment && department && prevDepartment !== department && disabled) {
      getModalityOptions();
      setPrevDepartment(department);
      setDisabled(false);
    }
    if (shouldHasDepartment && !department) {
      setPrevDepartment(null);
      setValueModality("");
      setDisabled(true);
    }
  }, [disabled, department, prevDepartment, getModalityOptions]);

  useEffect(() => {
    if (!shouldHasDepartment) {
      getModalityOptions();
      setDisabled(false);
    }
  }, []);

  return (
    <div className={cx(css.selectors, className)}>
      <Select
        label={label}
        options={optionsModality}
        value={valueModality}
        placeholder={placeholder}
        isClearable
        disabled={disabled}
        onChange={(value: IOption) => {
          if (value) {
            setValueModality(value);
            onCallback(value);
          } else {
            setValueModality("");
            onCallback(value);
          }
        }}
      />
    </div>
  );
};

export default ModalitySelect;
